import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import * as R from 'ramda'

import Input from '../../../components/form/Input'
import Select from '../../../components/form/Select'
import BubbleLoader from '../../../UniformComponents/BubbleLoader'
import Modal from '../../../UniformComponents/Modal'
import Button from '../../../UniformComponents/Button'

import './QuestionPipe.scss'

@observer
class QuestionPipe extends Component {
    renderMapping = () => {
        const { store } = this.props
        const { mapping, options } = store

        const renderPlaceholder = () => (
            <div className="placeholderText">
                {`${i18n.t('qlist.aiPiping.placeholder')} "${i18n.t('qlist.aiPiping.addOption')}"`}
            </div>
        )

        return Object.entries(mapping).length < 1
            ? renderPlaceholder()
            : (
                Object.entries(mapping).map(([id, { name, optionId }]) => (
                    <div
                        className="optionPipe"
                        key={id}
                    >
                        <Input
                            defaultValue={name}
                            name="name"
                            onBlur={({ value, name }) => store.changeValue(id, name, value)}
                        />
                        <Select
                            options={options}
                            value={options.find(({ value }) => value === optionId)}
                            name="optionId"
                            onBlur={({ value, name }) => store.changeValue(id, name, value)}
                        />
                        <i
                            className="fal fa-times-circle"
                            onClick={() => store.removeOptionFromMap(id)}
                        />
                    </div>
                )))
    }

    deleteMappings = () => {
        const { store } = this.props
        store.discard()
        store.qlistQuestion.toggleIsAI()
    }

    render() {
        const { store } = this.props
        const {
            targetQuestion,
            targetQuestionId,
            showModal,
            questionList,
            isLoading,
        } = store

        return (
            <Modal show={showModal} onClose={store.hide} cssClass="large" containsScroll>
                <div className="ai-piping-modal no-scroll-wrapper">
                    <div className="uc-modal__header">
                        <h2>{i18n.t('qlist.aiPiping.title')}</h2>
                        <p className="uc-modal__desc">{i18n.t('qlist.aiPiping.description')}</p>
                    </div>
                    {isLoading
                        ? (
                            <div style={{ height: 200, alignContent: 'center' }}>
                                <BubbleLoader />
                            </div>
                        ) : (
                            <div className="uc-modal__scrollable-content modal-body">
                                <Select
                                    onBlur={store.changeQuestion}
                                    value={targetQuestion}
                                    clearable={false}
                                    classNamePrefix="dropdown"
                                    className="exploriDropdown"
                                    options={questionList}
                                    placeholder="Select target question"
                                />
                                {this.renderMapping()}
                            </div>
                        )}
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div className="uc-modal__button-panel" style={{ justifyContent: 'start', paddingLeft: '4px' }}>
                            <Button
                                cssClass="tertiary"
                                onClick={store.addOptiontoMap}
                                disabled={R.isNil(targetQuestionId)}
                            >
                                {i18n.t('qlist.aiPiping.addOption')}
                            </Button>
                        </div>
                        <div className="uc-modal__button-panel">
                            <Button cssClass="error" onClick={this.deleteMappings}>
                                {i18n.t('delete')}
                            </Button>
                            <Button cssClass="primary" onClick={store.save}>
                                {i18n.t('save')}
                            </Button>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default QuestionPipe
